export const proceedsTypeDropdownItems = [
  { key: 0, value: "cash", text: "Cash" },
  { key: 1, value: "equity", text: "Equity" },
  { key: 2, value: "both", text: "Cash + Equity" },
];
